"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCard = exports.renderOverlayNode = exports.renderIdentityTitle = exports.renderSection = exports.renderLoading = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _i18n = require("../../utils/i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderLoading = function renderLoading(props) {
  var Spinner = _reactComponents.shapes.Spinner;
  return _react["default"].createElement("div", null, _react["default"].createElement(Spinner, {
    size: 'medium'
  }), (0, _i18n.tt)(props, 'loading'));
};

exports.renderLoading = renderLoading;

var renderSection = function renderSection(title, content) {
  var heading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  return _react["default"].createElement("div", {
    className: 'cas-section-wrap'
  }, title ? heading === 5 ? _react["default"].createElement("h5", {
    className: 'cas-section-title'
  }, title) : _react["default"].createElement("h4", {
    className: 'cas-section-title'
  }, title) : null, _react["default"].createElement("span", {
    className: 'cas-section-content'
  }, content));
};

exports.renderSection = renderSection;

var renderIdentityTitle = function renderIdentityTitle(a, current) {
  return a.link === (current || {}).link ? _react["default"].createElement("strong", null, a.name || a.id, " ", _react["default"].createElement("span", {
    className: 'cas-identity-title-type'
  }, "(", a.type, ")")) : _react["default"].createElement("span", null, a.name || a.id, " ", _react["default"].createElement("span", {
    className: 'cas-identity-title-type'
  }, "(", a.type, ")"));
};

exports.renderIdentityTitle = renderIdentityTitle;

var renderOverlayNode = function renderOverlayNode() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cas-saving-overlay';
  return _react["default"].createElement("div", {
    id: id,
    className: "cas-saving-overlay-hidden"
  }, _react["default"].createElement("img", {
    style: {
      position: 'fixed',
      top: 'calc(50% - 38px)',
      left: 'calc(50% - 38px)'
    },
    src: "https://static.ux.cimpress.io/mcp-ux-css/1.4/development/1.4.7/assets/spinner.svg",
    alt: "loading"
  }));
};

exports.renderOverlayNode = renderOverlayNode;

var renderCard = function renderCard(title, content) {
  // if Card is there - use it.
  if (_reactComponents.Card) {
    return _react["default"].createElement(_reactComponents.Card, {
      isMinimal: true,
      header: title
    }, content);
  }

  return _react["default"].createElement("div", {
    className: "card card-minimal"
  }, _react["default"].createElement("div", {
    className: "card-header"
  }, _react["default"].createElement("h5", {
    className: "card-title"
  }, title)), _react["default"].createElement("div", {
    className: "card-block"
  }, content));
};

exports.renderCard = renderCard;